(function(){
"use strict";
function start(){
 var bar=document.getElementById("demaBar");
 var cta=document.getElementById("demaAdd");
 var R=window.DemaRate;
 if(!bar||!cta||!R)return false;

 var t=bar.querySelector(".t");
 var rateRow=document.getElementById("demaBarRate");
 if(!rateRow&&t){
  rateRow=document.createElement("div");
  rateRow.id="demaBarRate";
  t.appendChild(rateRow);
 }
 function totale(){
  var pz=document.getElementById("demaBarPz");
  if(!pz)return 0;
  var s=(pz.textContent||"").replace(/[^\d,]/g,"").replace(",",".");
  return parseFloat(s)||0;
 }
 var lastTot=-1;
 function rate(){
  if(!rateRow)return;
  var tot=totale();
  if(tot<=0||tot===lastTot)return;
  lastTot=tot;
  var html="";
  var k=R.klarna(tot);
  if(k)html+='<span class="k">Klarna 3 rate &middot; '+R.euro(k.tre)+'</span>';
  var y=R.younited(tot);
  if(y)html+='<span class="y">Younited '+y.n+' rate &middot; '+R.euro(y.rata)+'</span>';
  rateRow.innerHTML=html;
 }

 var SOGLIA=420,on=false;
 function apply(){
  var r=cta.getBoundingClientRect();
  var vuoi=r.bottom < -SOGLIA;
  if(vuoi!==on){on=vuoi;bar.classList.toggle("on",vuoi)}
  rate();
 }
 var tick=false;
 function onScroll(){if(tick)return;tick=true;requestAnimationFrame(function(){tick=false;apply()})}
 window.addEventListener("scroll",onScroll,{passive:true});
 window.addEventListener("resize",onScroll,{passive:true});
 document.addEventListener("click",function(){setTimeout(apply,150);setTimeout(apply,600)},true);
 setInterval(apply,700);
 apply();

 var go=document.getElementById("demaBarGo");
 if(go)go.addEventListener("click",function(){
  cta.scrollIntoView({behavior:"smooth",block:"center"});
  setTimeout(function(){try{cta.focus()}catch(e){}},450);
 });
 window.__demaSticky="attivo";
 return true;
}
if(!start()){
 var n=0,t=setInterval(function(){ if(start()||++n>30)clearInterval(t) },250);
}
})();
